import React  from 'react';
import './App.css';
import './Part.css';
import PartLang from './PartLang.json';

import { useNavigate } from "react-router-dom";

class PropertyNew extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			propertyName: "",
			propertyType: "int",
		};

		this.onKeyDown = this.onKeyDown.bind(this);
		this.onPropertyNameChanged = this.onPropertyNameChanged.bind(this);
		this.onPropertyTypeChanged = this.onPropertyTypeChanged.bind(this);
		this.serverInsertProperty = this.serverInsertProperty.bind(this);
		this.onClickSaveButton = this.onClickSaveButton.bind(this);
		this.onClickCancelButton = this.onClickCancelButton.bind(this);
	}
	
	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}

	onPropertyNameChanged(value) {
		this.setState({propertyName: value});
	}
	
	onPropertyTypeChanged(event) {
		var value = event.target.value;
		this.setState({propertyType: value});
	}
	
	async serverInsertProperty(partID, propertyName, propertyType) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/insertpartpropertyrecord?partid=" + partID + "&propertyname=" + encodeURIComponent(propertyName) + "&propertytype=" + propertyType;
		
		const res = await fetch(url);
		await res.text();

		this.props.showToast(this.props.getLang(PartLang, "newPropertyCreated"));
		const navigate = this.props.navigate;
  		navigate("/setup/properties");
	}
		
	onClickSaveButton() {
		
		var propertyName = this.state.propertyName;
		if (propertyName === "") {
			this.props.showToast(this.props.getLang(PartLang, "propertyNotEmpty"));
			return;
		}

		var selectedPartID = this.props.selectedPartID;
		var propertyType = this.state.propertyType;
		this.serverInsertProperty(selectedPartID, propertyName, propertyType);
	}
	
	onClickCancelButton() {
		const navigate = this.props.navigate;
  		navigate("/setup/properties");
	}
	
	render() {		

		var selectedPartName = this.props.selectedPartName;

		return (
			<div className="ViewContainer1">
				<div style={{height: "30px"}}></div>
				<div className="ViewTopTitle">{this.props.getLang(PartLang, "newPartProperty")}</div>
				<div className="ViewTopText">{this.props.getLang(PartLang, "newPartPropertyInfoText")}</div>

				<div style={{height: "30px"}}></div>
				<div className="ViewBlockContainer">
					<div style={{height: "15px"}}></div>
					<div className="ViewBlockTitle">{this.props.getLang(PartLang, "propertyInfo")}</div>
					<div style={{height: "20px"}}></div>
					<div className="ViewContainer2">
						<p></p>
						<fieldset className="PropertyNewFieldset">
							<legend className="PropertyNewPartLegend">{this.props.getLang(PartLang, "part")}</legend> 
							<input
								className="PropertyNewPartInput" 
								id="propertyName" 
								type="text" 
								value={selectedPartName}
								disabled={true}
							/>
						</fieldset>
						<div style={{height: "20px"}}></div>
						<fieldset className="PropertyNewFieldset">
							<legend className="PropertyNewPartLegend">{this.props.getLang(PartLang, "propertyName")}</legend> 
							<input
								className="PropertyNewPartInput" 
								id="propertyName" 
								type="text" 
								autoFocus={true}
								onChange={(event) => this.onPropertyNameChanged(event.target.value)}
								onKeyDown={(event) => this.onKeyDown(event.keyCode)}
							/>
						</fieldset>
						<div style={{height: "20px"}}></div>
						<fieldset className="PropertyNewFieldset">
							<legend className="PropertyNewPartLegend">{this.props.getLang(PartLang, "propertyType")}</legend> 
							<div className="PropertyNewTypeContainer" onChange={this.onPropertyTypeChanged}>
								<input className="PropertyNewNameInput" type="radio" value="int" name="PropertyType" defaultChecked={true} /> int
								<input className="PropertyNewNameInput" type="radio" value="float" name="PropertyType" /> float
								<input className="PropertyNewNameInput" type="radio" value="text" name="PropertyType" /> text							
							</div>
						</fieldset>
					</div>
					<div style={{height: "60px"}}></div>
					<div className="ViewContainerButtons">
						<div style={{width: "200px"}}></div>
						<button className="ViewCancelButton" onClick={this.onClickCancelButton}>{this.props.getLang(PartLang, "cancel")}</button>
						<div style={{width: "20px"}}></div>
						<button className="ViewSaveButton" onClick={this.onClickSaveButton}>{this.props.getLang(PartLang, "save")}</button>
					</div>
					<div style={{height: "50px"}}></div>
				</div>

				<div style={{height: "100px"}}></div>
			</div>
		);
	}
}

export default function PropertyNewFunction(props) {
	const navigate = useNavigate();
	return <PropertyNew {...props} navigate={navigate} />;
}

